import styled from '@rsos/theme/styled';

export const AgencyList = styled.div`
  max-height: 248px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 8px;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 8px 8px 32px;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primaryBase};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.secondaryText};
  }
`;

export const AgencyRow = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 8px;
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  border-radius: 4px;
  cursor: pointer;
  background-color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.colors.foreground : 'transparent'};

  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const AgencyDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AgencyName = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const AgencySubtitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const InfoBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.foreground};
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const ErrorBanner = styled(InfoBanner)`
  color: ${({ theme }) => theme.colors.lightDanger};
  width: 100%;
  box-sizing: border-box;
`;
